import axios from "@/axios";

const endpoint = "/business";

const Business = {
  search: async (params) => {
    return axios
      .get("/business/search", {
        params,
      })
      .then(({ items, ...pagination }) => {
        return {
          businesses: items,
          pagination: {
            ...pagination,
            pages: Math.ceil(pagination.total / pagination.limit),
          },
        };
      })
      .catch((error) => {
        console.error("Error fetching businesses:", error);
        return {
          businesses: [],
          pagination: {
            limit: 20,
            total: 0,
            page: 1,
            pages: 1,
          },
        };
      });
  },
  advanceSearch: async (params) => {
    return axios
      .post("/advanced/search", {
        ...params,
        name: params.businessName
      })
      .then((results) => {
        return {
          businesses: results.map(result => ({
            ...result.address,
            name: result.businessName,
            phone: result.phone,
            description: "",
          })),
          pagination: {}
        };
      })
      .catch((error) => {
        console.error("Error fetching businesses from advanced search:", error);
        return {
          businesses: [],
          pagination: {}
        };
      });
  },
  createAdvancedSearchBusiness: async (data) => {
    return axios
      .post("/advanced/search/create", data)
      .then(({ businessId }) => {
        return businessId
      })
      .catch((error) => {
        console.error("Error fetching business from advanced search:", error);
        return error?.businessId || "";
      });
  },
  get: async (id) => {
    return axios
      .get(`${endpoint}/${id}`)
      .then((business) => {
        const storedSearches = JSON.parse(
          localStorage.getItem("recentSearches") || "[]"
        );

        const storedBusiness = storedSearches.find(
          (b) => b.businessId === business.id
        );

        return {
          ...business,
          addressLine1: business.street || "",
          addressLine2:
            `${business.city}, ${business.state} ${business.zip}` || "",
          photo:
            storedBusiness?.businessPhoto || business.photo?.photoUri || null,
        };
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          return { id: null, accessDenied: true };
        }
        return { id: null };
      });
  },
  score: async (id) => {
    return axios
      .get(`${endpoint}/${id}/score`)
      .then(({ betaScoreOutput }) => ({
        businessId: betaScoreOutput?.businessId ?? null,
        score: {
          score: betaScoreOutput?.betaScore ?? null,
          ratingLabel: betaScoreOutput?.betaScoreRating ?? "",
          tier: betaScoreOutput?.betaScoreTier ?? "",
          riskLevel: betaScoreOutput?.betaScoreRiskLevel ?? "",
          bucket: betaScoreOutput?.betaScoreColorBucket ?? null,
          dataConfidence: betaScoreOutput?.betaScoreConfidence ?? "",
          date: new Date(),
        },
        summary: betaScoreOutput?.betaScoreSummary ?? "",
        factors: betaScoreOutput?.featureDetails ?? [],
      }))
      .catch(() => ({
        businessId: null,
        score: {
          score: null,
          ratingLabel: "",
          tier: "",
          bucket: null,
          dataConfidence: "",
          date: null,
        },
        summary: "",
        factors: [],
      }));
  },
  getLoanBeacon: async (id) => {
    return axios
      .get(`${endpoint}/${id}/loan-beacon`)
      .then(({ loanBeacon }) => ({
        isActive: loanBeacon?.isActive ?? false,
      }))
      .catch(() => ({ isActive: false }));
  },
  setLoanBeacon: async (id) => {
    return axios
      .patch(`${endpoint}/${id}/loan-beacon`)
      .then(({ loanBeacon }) => ({
        isActive: loanBeacon?.isActive ?? false,
        success: true,
      }))
      .catch((error) => {
        if (error?.response?.status === 403) {
          return { success: false, forbidden: true };
        }
        return { success: false };
      });
  },
};

export default Business;
